import { render, staticRenderFns } from "./hazard.vue?vue&type=template&id=689b2241&"
import script from "./hazard.vue?vue&type=script&lang=js&"
export * from "./hazard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports